import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IFilterItemViewModel } from '@ncg/data';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { SettingsService } from '../../core/settings.service';

@Component({
    selector: 'ncg-product-item-content',
    template: `
        <div class="product-item__list-details columns is-variable is-mobile">
            <div class="column is-narrow" *ngIf="item.year">
                <div class="product-item__list-detail">
                    <div class="product-item__list-detail--key">{{ 'product_item.label_year' | translate }}</div>
                    <div class="product-item__list-detail--value">{{ item.year }}</div>
                </div>
            </div>
            <div class="column is-narrow" *ngIf="item.mileage">
                <div class="product-item__list-detail">
                    <div class="product-item__list-detail--key">{{ 'product_item.label_mileage' | translate }}</div>
                    <div class="product-item__list-detail--value">{{ item.mileage }}</div>
                </div>
            </div>
            <div class="column is-narrow" *ngIf="item.propellant">
                <div class="product-item__list-detail">
                    <div class="product-item__list-detail--key">{{ 'product_item.label_propellant' | translate }}</div>
                    <div class="product-item__list-detail--value">{{ item.propellant }}</div>
                </div>
            </div>
            <div class="column is-narrow" *ngIf="item.range; else kmPerLiter">
                <div class="product-item__list-detail">
                    <div class="product-item__list-detail--key">{{ 'product_item.label_range' | translate }}</div>
                    <div class="product-item__list-detail--value">{{ 'product_item.range' | translate: { range: item.range } }}</div>
                </div>
            </div>
            <ng-template #kmPerLiter>
                <div class="column is-narrow" *ngIf="item.kmPerLiter">
                    <div class="product-item__list-detail">
                        <div class="product-item__list-detail--key">{{ 'product_item.label_km_per_liter' | translate }}</div>
                        <div class="product-item__list-detail--value">
                            {{ item.kmPerLiter | number: '1.1' : culture }}
                            <span class="is-hidden-desktop">{{ 'product_item.label_km_per_liter' | translate }}</span>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="column is-narrow" *ngIf="item.dealerName">
                <div class="product-item__list-detail">
                    <div class="product-item__list-detail--key">{{ 'product_item.label_dealer_name' | translate }}</div>
                    <div class="product-item__list-detail--value">{{ item.dealerName }}</div>
                </div>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductItemContentComponent implements OnInit, OnDestroy {
    @Input() item: IFilterItemViewModel;
    culture: string;

    private readonly unsubscribe = new Subject<void>();

    constructor(
        private readonly settingsService: SettingsService,
        private readonly cd: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.settingsService
            .get()
            .pipe(take(1), takeUntil(this.unsubscribe))
            .subscribe((settings) => {
                this.culture = `${settings.seoLanguage}-${settings.seoCountry}`;
                this.cd.markForCheck();
            });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
